module.exports = __webpack_public_path__ + "static/media/34.435c2875.jpg";